module.exports = __webpack_public_path__ + "img/flag-gb.7041d800.svg";